var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "email-listing__pagination" }, [
    _c(
      "div",
      { staticClass: "email-listing__pagination-limit" },
      [
        _c("span", { staticClass: "typographies-paragraph-small-bold" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t.__("ListingWrapper.pagination_text")) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "CompassSelect",
          {
            staticClass: "email-listing__pagination-select",
            attrs: {
              value: _vm.pagination.limit,
              menuClass: "email-listing__pagination-select-menu",
              size: "small"
            },
            on: { "update:value": _vm.handleLimitChange }
          },
          _vm._l(_vm.paginationLimitOptions, function(option, index) {
            return _c("CompassDropdownSelectOption", {
              key: index,
              attrs: { value: option, label: option.toString() }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "email-listing__pagination-navigation" },
      [
        _c("CompassIconButton", {
          attrs: {
            size: "small",
            icon: "caret-left",
            disabled: _vm.isPreviousPageDisabled
          },
          on: { click: _vm.previousPage }
        }),
        _vm._v(" "),
        _vm.displayTotalResults
          ? _c("span", { staticClass: "typographies-paragraph-small-bold" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.textPagination) + "\n        "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("CompassIconButton", {
          attrs: {
            size: "small",
            icon: "caret-right",
            disabled: _vm.isNextPageDisabled
          },
          on: { click: _vm.nextPage }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }